import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { noData } from '@assets/index';
import styles from './NoData.module.scss';
const NoData = ({ text }) => {
    return (_jsxs("div", Object.assign({ className: styles.empty, "data-testid": "empty-block" }, { children: [_jsx("img", { src: noData, alt: "no data" }), _jsx("h2", { children: text })] })));
};
export default NoData;
